var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCarpeta({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0,0,256,256",
    width: "50px",
    height: "50px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "#f8f9fa",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(5.12,5.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,4c-1.65234,0 -3,1.34766 -3,3v26.09375c1.46484,-7.79687 3.10547,-16.54297 3.1875,-16.96875c0.50781,-2.58984 2.46094,-4.125 5.25,-4.125h38.5625v-1c0,-1.65234 -1.34766,-3 -3,-3h-25.96875c-0.27734,-0.10156 -0.84766,-1.00781 -1.15625,-1.5c-0.76953,-1.22656 -1.55859,-2.5 -2.875,-2.5zM8.4375,14c-1.28125,0 -2.875,0.44922 -3.28125,2.53125c-0.12891,0.64844 -4.02344,21.37891 -5.15625,27.40625v0.0625c0,1.65234 1.34766,3 3,3h39c1.62109,0 2.94531,-1.29687 3,-2.90625l4.96875,-26.90625l0.03125,-0.1875c0,-1.65234 -1.34766,-3 -3,-3z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarpeta);
export default __webpack_public_path__ + "static/media/carpeta.66c78a57e4cc8db91a5ca91c1dc0c427.svg";
export { ForwardRef as ReactComponent };